<template>
  <div class="page-header">
    <div class="header-content">
      <!-- Logo -->
      <div class="logo">LK</div>

      <!-- 导航菜单 -->
      <nav class="nav-links">
        <a href="#" class="nav-item active">道具点位</a>
        <a href="#" class="nav-item">评论管理</a>
        <a href="#" class="nav-item">点位管理</a>
      </nav>

      <!-- 游戏切换按钮组 -->
      <div class="game-switcher">
        <div class="button-group">
          <button
            :class="['switch-btn', { active: currentGame === 'valorant' }]"
            @click="switchGame('valorant')"
          >
            <img src="@/assets/val.png" class="game-icon" alt="Valorant" />
            无畏契约
          </button>
          <button
            :class="['switch-btn', { active: currentGame === 'cs2' }]"
            @click="switchGame('cs2')"
          >
            <img src="@/assets/cs2.png" class="game-icon" alt="CS2" />
            CS2
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  data() {
    return {
      currentGame: 'valorant' // 默认当前为无畏契约
    }
  },
  methods: {
    switchGame(game) {
      if (this.currentGame === game) return;
      this.currentGame = game;
      // 这里可以添加路由跳转逻辑，例如：
      // if (game === 'cs2') this.$router.push('/cs2')
      // else this.$router.push('/valorant')
      console.log(`Switched to ${game}`);
      this.$emit('game-change', game);
    }
  }
}
</script>

<style scoped>
.page-header {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  padding: 0 20px;
  height: 64px;
  display: flex;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  margin-right: 40px;
  color: #000;
}

.nav-links {
  display: flex;
  gap: 20px;
  flex: 1;
}

.nav-item {
  text-decoration: none;
  color: #666;
  font-size: 16px;
  padding: 5px 0;
  position: relative;
}

.nav-item:hover, .nav-item.active {
  color: #409eff; /* 蓝色高亮 */
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: -22px; /* 调整下划线位置以匹配 header 高度 */
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #409eff;
}

/* 按钮组样式 */
.game-switcher {
  /*margin-left: auto;*/
  border-left: 1px solid #eee;
  padding-left: 20px;
}

.button-group {
  display: flex;
  background-color: #e2e6eb; /* 加深灰色背景 */
  border-radius: 8px; /* 稍微加大圆角 */
  padding: 4px; /* 增加内边距，让背景露出来 */
}

.switch-btn {
  border: none;
  background: transparent;
  padding: 6px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  color: #606266;
  transition: all 0.3s;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px; /* 图标和文字之间的间距 */
}

.game-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  border-radius: 4px; /* 如果图标是圆角的，这里可以调整 */
}

.switch-btn.active {
  background-color: #409eff;
  color: #fff;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.4);
  font-weight: 600;
}

.switch-btn:hover:not(.active) {
  color: #409eff;
  background-color: rgba(64, 158, 255, 0.1);
}
</style>
